import React, { useLayoutEffect } from "react";
import { DentalBrochure2026, MaxCareDentalLogo } from "../../../../../assets";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";
import VEBDentalImage from "../../../../../assets/VEBPlanImages/VEBDentalImage.avif";
import "./dental.scss";

const Dental: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="dental-plan-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Dental</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={MaxCareDentalLogo} alt="" />
					</div>
					<div className="plan-description">
						<span>
							When you or a loved one is dealing with a significant dental condition, the financial burden
							can be overwhelming. While primary dental insurance may assist with some of the oral care
							expenses, individuals often face challenges related to time away from work and costs that
							may not be covered by other insurance policies.
						</span>

						<h3>Stay focused on getting well</h3>
						<span>
							A Max Care Dental Insurance policy offers an extra layer of financial security during
							challenging times related to dental health. It provides benefits that can be used to manage
							expenses and safeguard your savings, allowing you to focus on improving your oral health.
						</span>
					</div>
				</div>
				<div className="right-section">
					<img src={VEBDentalImage} alt="VEBDentalImage" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={DentalBrochure2026} />
			</div>
		</div>
	);
};

export default Dental;
